<template>
  <div class="settlement-search-block">
    <Form
      ref="searchForm"
      :model="formInline"
      label-position="right"
      :label-width="0"
      inline
      style="position: relative"
      class="search-list-430 search-wrapper-430 flex flexsb"
    >
      <div>
        <FormItem v-if="isShowOrg != -1">
          <Input
            v-model="formInline.statementId"
            type="text"
            placeholder="请输入账单编号"
            clearable
            class="search-input-430"
          >
          </Input>
        </FormItem>
        <FormItem v-if="isShowOrg != -1" label="">
          <SearchSelectOrg
            ref="orgRef"
            :org-id="formInline.orgId"
            :show-org="+isShowOrg===3?isShowOrg:-1"
            :tab="tab"
          ></SearchSelectOrg>
        </FormItem>
        <FormItem v-if="isShowSch != -1" class="must" label="">
          <SearchSelectSch
            ref="schRef"
            :sch-id="formInline.schId"
            :show-sch="isShowSch"
          ></SearchSelectSch>
        </FormItem>
        <FormItem v-if="isShowBank" :class="tableType == 1 ? '' : 'must'">
          <Select
            v-model="formInline.bankId"
            :placeholder="`${
              tableType == 1 ? '请选择银行' : '请选择机构开户银行'
            }`"
            class="search-select-430"
          >
            <Option
              v-for="item in bankData"
              :key="item.value"
              :value="item.value"
            >{{ item.label }}</Option>
          </Select>
        </FormItem>

        <FormItem v-if="isShowOrg != -1">
          <SearchSelectAccount ref="accountRef"></SearchSelectAccount>
        </FormItem>

        <FormItem v-if="isShowEdu != -1" class="must" label="">
          <SearchSelectEdu
            :edu-id="formInline.eduId"
            :org-id="formInline.orgId"
            :show-edu="isShowEdu"
            @on-edu-change="onEduChange"
          ></SearchSelectEdu>
        </FormItem>
        <FormItem>
          <DatePicker
            v-model="month"
            type="month"
            placeholder="请选择月份"
            style="width: 200px"
            :transfer="true"
            @on-change="onMonthChange"
          ></DatePicker>
        </FormItem>

        <FormItem v-if="isShowStsta != -1" label="">
          <Select
            v-model="formInline.approvalSts"
            placeholder="请选择对账状态"
            class="search-select-430"
          >
            <Option
              v-for="item in rlStatusData"
              :key="item.value"
              :value="item.value"
            >{{ item.label }}</Option>
          </Select>
        </FormItem>

        <FormItem v-if="isShowStsta != -1" label="">
          <Select
            v-model="formInline.settleSts"
            placeholder="请选择结算状态"
            class="search-select-430"
          >
            <Option
              v-for="item in stStatusData"
              :key="item.value"
              :value="item.value"
            >{{ item.label }}</Option>
          </Select>
        </FormItem>
        <FormItem v-if="isShowYearTerms != -1" label="">
          <CascaderYearTerms
            ref="cascaderYearTerms"
            :clearable="true"
            :placeholder="`请选择学期`"
            :cache-year-terms="cacheYearTerms"
            @on-init="onYearTermInit"
          ></CascaderYearTerms>
        </FormItem>
        <Button
          type="primary"
          style="margin-left: 16px"
          @click="handleSubmit('formInline')"
        >查询</Button>
        <Button style="margin-left: 16px" @click="handleReset">重置</Button>
      </div>
      <!-- && userInfo.userType == 5 -->
      <Button
        v-if="[1].includes(portOrg)"
        v-auth="`SETTLE_AUDIT_SETTING`"
        type="primary"
        class="btn-check-flow"
        @click="handleToCheckFlow"
      >配置结算审批流程</Button>
    </Form>
    <div class="download-main flex align-items justify-content_end">
      <Checkbox
        v-if="(portOrg == 0 || portOrg == 2) && tableType == 1"
        v-model="isShowZero"
      >不显示0元账单</Checkbox>
      <div class="row" style="padding-top: 8px">
        <Button
          v-if="tab == 1 && isShowSettingBtn"
          type="primary"
          style="margin-right: 12px"
        ><p class="flex">
          <span @click="handleBatchSetting">批量设置</span>
          <Divider
            v-if="batchData.length > 0"
            class="line"
            type="vertical"
            style="margin-left: 18px"
          ></Divider>
          <Spin
            v-if="batchData.length > 0"
            size="small"
          ><Icon
            type="ios-loading"
            size="16"
            color="#ffffff"
            class="spin-icon-load"
            @click="handleViewSetting"
          ></Icon></Spin></p></Button>
        <Button
          v-if="isShowDownloadBtn"
          type="primary"
          @click="handleDownload"
        >下载</Button>
        <Button v-if="portOrg == 0&&tableType == 1" type="primary" style="margin-left: 12px" @click="handleToFileDownloadPage">文件管理</Button>
      </div>
    </div>
    <BatchAdminSettingCheck
      ref="batchAdminSettingCheckRef"
      @on-finish="onBatchCheckFinish"
    ></BatchAdminSettingCheck>
    <BatchAdminSettingInfo
      ref="batchAdminSettingInfoRef"
      @on-success="onBatctInfoSuccess"
    ></BatchAdminSettingInfo>
    <BatchAdminSettingResult
      ref="batchAdminSettingResultRef"
      @on-success="onBatctResultFinish"
    ></BatchAdminSettingResult>
  </div>
</template>

<script>
import { bankData, rlStatusData1, rlStatusData2, stStatusData } from '../data/SearchBlock.js';
import { mapState, mapActions } from 'vuex';
import SearchSelectOrg from './SearchSelectOrg.vue';
import SearchSelectSch from './SearchSelectSch.vue';
import SearchSelectEdu from './SearchSelectEdu.vue';
import SearchSelectAllEdu from './SearchSelectAllEdu.vue';
import CascaderYearTerms from '@c/searchBlock/CascaderYearTerms.vue';
import orderCenterApi from '@/request/orderCenter/index.js';
import commonApi from '@/request/common/index.js';
import courseSchedulCenter from '@/request/courseSchedulCenter/index.js';
import BatchAdminSettingCheck from './BatchAdminSettingCheck';
import BatchAdminSettingInfo from './BatchAdminSettingInfo';
import BatchAdminSettingResult from './BatchAdminSettingResult';
import SearchSelectAccount from '@c/searchBlock/SearchSelectAccount.vue';
import timer from '@/utils/timer.js';
import { deepCopy } from '@/utils/utils.js';
import { judgeIsNumber } from '@/utils/utils';
export default {
  components: {
    SearchSelectOrg,
    SearchSelectSch,
    SearchSelectEdu,
    SearchSelectAllEdu,
    CascaderYearTerms,
    BatchAdminSettingCheck,
    BatchAdminSettingInfo,
    BatchAdminSettingResult,
    SearchSelectAccount
  },
  props: {

  },
  data() {
    return {
      tab: '1',
      bankData: bankData,
      rlStatusData: rlStatusData2,
      stStatusData,
      tablePortOrg: this.$route.meta.tablePortOrg,
      month: '',
      formInline: {
        eduId: '0',
        eduName: '',
        bankId: '-1',
        settleSts: '-1', // 结算状态
        approvalSts: '-1',
        orgName: '',
        orgId: '',
        schId: '0',
        schName: '',
        settleMonth: null,
        statementId: ''
      },
      // tableType: 1: 运营平台 - 机构端->机构 2:运营平台 - 学校端 ->学校 3:教育局
      tableType: this.$route.meta.tableType,
      portOrg: Number(localStorage.getItem('portOrg')),
      isShowZero: true,
      // termId: '',
      // termList: [],
      cacheYearTerms: [], // 缓存的学期
      isWxAccount: false, // 是否含有微信账单
      batchSettlementTaskId: '', // 批量任务id
      batchData: []

    };
  },
  computed: {
    ...mapState({
      settlementSearch: state => state.orderCenter.settlementSearch,
      userInfo: state => state.userInfo
    }),
    isShowDownloadBtn() {
      // 运营端 机构表格 或者 学校表格
      return ((this.portOrg == 0 || this.portOrg == 2) && this.tableType == 1) || this.tableType == 2;
    },
    // 批量设置按钮
    isShowSettingBtn() {
      // 运营端 机构表格 或者 学校表格
      return this.portOrg == 0 && this.tableType == 1;
    },
    isShowAllEdu() {
      let status = -1;

      if (this.tableType == 3) {
        status = this.portOrg;
      }
      return status;
    },
    isShowSch() {
      let status = -1;
      if (this.tableType == 2 || this.tableType == 1) {
        status = this.portOrg;
      }
      return status;
    },
    isShowOrg() {
      let status = -1;
      if (this.tableType == 1) {
        status = this.portOrg;
      }
      return status;
    },
    isShowEdu() {
      let status = -1;
      if (this.tableType == 3) {
        status = this.portOrg;
      }
      return status;
    },
    isShowYearTerms() {
      let status = -1;
      if (this.tableType == 1 || this.tableType == 3 || this.tableType == 2) {
        status = this.portOrg;
      }
      console.log(status, '拿到的参数', this.tableType);
      return status;
    },
    isShowBank() {
      return this.tableType != 3 && this.tab == 1;
    },
    // 运营端 机构端 -机构列表才显示
    isShowRlsta() {
      let status = -1;
      if (this.tableType == 1) {
        status = this.portOrg;
      }

      return status;
    },
    // 运营端 机构端 -机构列表才显示
    isShowStsta() {
      let status = -1;

      if (this.tableType == 1) {
        status = this.portOrg;
      }

      return status;
    },
    // 是否显示tab
    isShowTab() {
      return [0, 3].includes(this.portOrg) && this.tableType == 1 && this.isWxAccount;
    }

  },
  watch: {
    'formInline.bankId'(val) {
      // 现在启动平安银行模式下，机构/学校提供方的账单结算审批流程均接入教育局审批，所以搜索条件要保持一致了
      this.rlStatusData = rlStatusData2;
      this.formInline.approvalSts = '-1';
    },
    tab(val) {
      this.formInline.eduId = 0;
      this.formInline.eduName = '';
    }
  },
  created() {

  },
  destroyed() {
    timer.clearTimer('indexBatchSettlementTask');
  },
  mounted() {
    //
    this.init();
  },

  methods: {
    ...mapActions('orderCenter', [
      'udpateSettlementSearchByAction'
    ]),
    async init() {
      //   if (this.portOrg == 3) {
      // await this.getConfigRelList();
      //   } else {
      //     this.isWxAccount = true;
      //   }
      //   await this.initSearchData();
      // 如果是有学期的，等拿回来学期再发起请求
      if (this.isShowYearTerms != -1) {

      } else if ([3].includes(this.portOrg)) {
        this.handleSubmit();
      } else if (this.tableType == 2) {
        this.handleSubmit();
      } else if ([0, 2].includes(this.portOrg) && this.tableType == 1) {
        // this.handleSubmit();
      } else if ([0].includes(this.portOrg) && this.tableType == 3 && this.settlementSearch && this.settlementSearch.eduId != 0) {
        //  this.handleSubmit();
      }
      this.batchSettlementTaskId = localStorage.getItem('batchSettlementTaskId');
      // 运营端 && 结算账单（机构）
      if (this.portOrg == 0 && this.tableType == 1) {
        this.getTaskStatusList();
        timer.addTimer('indexBatchSettlementTask', this.getTaskStatusList, 3000);
      }
    },
    async getTaskStatusList() {
      const params = {
        busiCode: 13, //  业务编码 3-批量结算账单
        pageSize: 100,
        pageNo: 1,
        // busiObjIds: [],
        upBatchIds: this.batchSettlementTaskId ? [this.batchSettlementTaskId] : [], // 父级任务id
        procStsList: [0, 2],
        exeFlag: 1
      };

      const res = await courseSchedulCenter.getTaskStatusListApi(params);
      if (this.batchData.length > 0 && res.message.list.length == 0) {
        this.handleSubmit();
      }
      if (res.status == 200 && res.message.list.length > 0) {
        this.batchData = res.message.list.map(item => {
          return { ...item.properties, procSts: item.batchProcData.procSts };
        });
      } else {
        if (res.message.list == 0) {
          localStorage.removeItem('batchSettlementTaskId');
        }
        timer.clearTimer('indexBatchSettlementTask');
      }
    },
    onTabClick(tab) {
      tab == 1 ? this.formInline.bankId = 0 : this.formInline.bankId = 'wChat';
      this.handleSubmit('formInline');
    },
    // 获取单位分账规则
    // async getConfigRelList() {
    //   return new Promise(async (resolve, reject) => {
    //     const res = await commonApi.getConfigRelList();
    //     if (res.status == 200) {
    //       this.isWxAccount = res.message.findIndex(item => { return item.inAccountType == 3; }) != -1;
    //     }
    //     resolve(res);
    //   });
    // },
    // 是否显示
    async initSearchData() {
      return new Promise(async(resolve, reject) => {
        if (this.portOrg == 1) {
          const userInfo = JSON.parse(localStorage.getItem('userInfo'));
          // await this.getYearTermList(userInfo.orgId)
        }

        if (this.settlementSearch) {
          for (const k in this.settlementSearch) {
            this.formInline[k] = this.settlementSearch[k];
            if (k == 'isShowZero') {
              this.isShowZero = this.settlementSearch[k] == 0;
            }
            if (k == 'settleMonth' && this.settlementSearch[k]) {
              this.month = this.settlementSearch[k].substring(0, 10);
            }
            if (k == 'yearCode' && this.settlementSearch[k]) {
              this.cacheYearTerms = [this.settlementSearch[k], String(this.settlementSearch['termCode'])];
            }
          }
        }
        resolve();
      });
    },
    onYearTermInit() {
      this.handleSubmit();
      // this.handleSearch()
    },
    async handleGetVal() {
      return new Promise(async(resolve, reject) => {
        if (this.$refs.orgRef) {
          const { orgName, orgId } = await this.$refs.orgRef.getVal();
          this.formInline.orgName = orgName;
          this.formInline.orgId = orgId;
        }
        if (this.$refs.schRef) {
          const { schName, schId } = await this.$refs.schRef.getVal();
          this.formInline.schName = schName;
          this.formInline.schId = schId;
        }
        if (this.$refs.accountRef) {
          const { acctName, settlementSheetOrgId } = await this.$refs.accountRef.getVal();
          this.formInline.acctName = acctName;
          this.formInline.settlementSheetOrgId = settlementSheetOrgId;
        }
        resolve();
      });
    },

    // async getYearTermList(orgId) {
    //   return new Promise(async (resolve, reject) => {
    //     let res = await orderCenterApi.getYearTermList({ orgId: orgId })
    //     if (res.status == 200) {
    //       this.termList = res.message
    //       let yearTerm = res.message.filter(item => {
    //         return item.yearStr == '2022-2023学年第二学期'
    //       })
    //       if (yearTerm.length) {
    //         this.termId = yearTerm[0]['termId']
    //       }
    //       resolve()
    //     }
    //   })
    // },
    getYearTermCode() {
      const yearTerm = this.$refs.cascaderYearTerms ? this.$refs.cascaderYearTerms.getResult() : [];
      return {
        termCode: yearTerm[1],
        yearCode: yearTerm[0]
      };
      // return this.tableType != 2 ? {
      //   termCode: yearTerm[1],
      //   yearCode: yearTerm[0]
      // } : {};
    },
    async handleSubmit() {
      console.log('执行了拿到搜索参数');
      await this.handleGetVal();
      const res = this.checkParameter();
      console.log(res, '拿到的---', this.tableType);
      if (res.code != 200) {
        this.$Message.warning(res.str);
        return null;
      }
      this.$nextTick(() => {
        this.udpateSettlementSearchByAction(res.data);
        console.log(res, '拿到的---搜索参数---');
        this.$emit('on-finish', res);
      });
    },
    // 重置
    handleReset() {
      const copyInfo = deepCopy(this.formInline);
      const bankId = this.formInline.bankId;
      this.formInline = {
        eduId: '0',
        eduName: '',
        bankId: '-1',
        settleSts: '-1', // 结算状态
        approvalSts: '-1',
        orgName: '',
        orgId: '',
        schId: '0',
        schName: '',
        settleMonth: null,
        statementId: ''
      };
      //   this.formInline.bankId = bankId == 3 ? bankId : '0';
      switch (Number(this.portOrg)) {
        case 1:
          this.formInline.eduId = copyInfo.eduId;
          break;
        case 2:
          this.formInline.schId = copyInfo.schId;
          this.formInline.schName = copyInfo.schName;
          break;
        case 3:
          this.formInline.orgId = copyInfo.orgId;
          this.formInline.orgName = copyInfo.orgName;
          break;
      }
      this.month = '';
      this.$refs.orgRef && this.$refs.orgRef.handleClear();
      this.$refs.schRef && this.$refs.schRef.handleClear();
      this.$refs.accountRef && this.$refs.accountRef.handleClear();

      this.handleSubmit();
    },
    onMonthChange(month) {
      if (month) {
        this.formInline.settleMonth = month;
      } else {
        this.formInline.settleMonth = null;
      }
    },
    // 跳转流程设置页
    handleToCheckFlow() {
      this.$router.push({
        name: 'financeCenter_settlement_edu_checkFlow'
      });
    },
    // 学校变化
    onSchChange(sch) {
      this.formInline.schId = sch.schId;
      this.formInline.schName = sch.schName;
    },
    // 教育局选择变化
    handleEduOnChange() {
    },
    // 教育局变化
    onEduChange(edu) {
      this.formInline.eduName = edu.eduName,
      this.formInline.eduId = edu.eduId;
    },
    getTransferData() {
      const data = {};
      return data;
    },
    checkParameter() {
      let code = 200; let str = '请选中学校、银行后进行查询';
      const { eduId, statementId } = this.formInline;
      const backData = {
        portOrg: Number(this.portOrg),
        tableType: this.tableType,
        data: this.formInline
      };

      // 运营平台 -> 结算账单 - 机构
      if (this.tableType == 1) {
        backData.data.isShowZero = this.isShowZero ? 0 : 1;
        const yearTerm = this.getYearTermCode();
        backData.data = {
          ...backData.data,
          ...yearTerm
        };
        str = this.portOrg == 0 ? '请选中银行后进行查询' : '请选中银行后进行查询';
        if (
          !judgeIsNumber(statementId)
        ) {
          code = 501;
          str = '账单编号只能填写数字～';
        }
        return {
          ...backData,
          code: code,
          str: str,
          remark: '运营平台 - 结算账单 - 机构'
        };
      }
      if (this.tableType == 2) {
        str = '请选中学校、银行后进行查询';
        const yearTerm = this.getYearTermCode();
        backData.data = {
          ...backData.data,
          ...yearTerm
        };
        return {
          ...backData,
          code: code,
          // code: [schId, bankId].indexOf('0') != -1 ? 501 : 200,
          str: str,
          remark: '运营平台 - 结算账单 - 学校'
        };
      }

      if (this.tableType == 3) {
        const yearTerm = this.getYearTermCode();
        backData.data = {
          ...backData.data,
          ...yearTerm
        };
        str = '请选中教育局后进行查询';
        return {
          ...backData,
          code: eduId === '0' || !eduId ? 501 : code,
          str: str,
          remark: '运营平台 - 结算账单 - 教育局'
        };
      }
    },
    handleViewSetting() {
      this.$refs.batchAdminSettingResultRef.handleShow();
    },
    // 批量设置
    handleBatchSetting() {
      // statementSts = 8 && bankId &&  settleMonth && settleCycle  statementSts
      const selectionRows = this.$parent.$refs.settlementTableRef.selectionRows;
      if (this.batchData.length > 0) {
        this.$Message.warning('存在正在处理中的任务，请稍后再次尝试');
        return null;
      }
      if (selectionRows.length == 0) {
        this.$Message.warning('请先选择要设置的数据～');
        return null;
      }
      const everySta = selectionRows.every(function(item) {
        return item.bankId == selectionRows[0]['bankId'] && item.settleMonth == selectionRows[0]['settleMonth'] && item.settleCycle == selectionRows[0]['settleCycle'] && item.approvalSts == 1;
      });
      if (!everySta) {
        this.$Message.warning('仅支持一个月份下相同银行中按月考勤节次类型的待运营确认状态账单，请核对后重新选中');
        return null;
      }
      this.$refs.batchAdminSettingCheckRef.handleShow(selectionRows);
      // '839543869799424001'
      // this.$refs.batchAdminSettingResultRef.handleShow()
      // this.$refs.batchAdminSettingInfoRef.handleShow()
    },
    onBatchCheckFinish(id) {
      this.$refs.batchAdminSettingResultRef.handleShow(id);
      this.getTaskStatusList();
      timer.addTimer('indexBatchSettlementTask', this.getTaskStatusList, 3000);
    },
    onBatctResultFinish(id) {
      this.$refs.batchAdminSettingInfoRef.handleShow(id);
    },
    onBatctInfoSuccess() {
      this.handleSubmit('formInline');
    },
    // 下载
    async handleDownload() {
      await this.handleGetVal();
      const res = this.checkParameter();
      if (res.code != 200) {
        this.$Message.warning(res.str);
        return null;
      }
      this.$nextTick(() => {
        this.udpateSettlementSearchByAction(res.data);
        this.$emit('on-download', res);
      });
    },
    handleToFileDownloadPage() {
      this.$router.push({
        name: 'financeCenter_settlement_org_fileDownload'
      });
    }
  }
};
</script>
<style lang="scss"  >
.settlement-search-block {
  padding-bottom: 8px;
  .must {
    .ivu-form-item-label {
      &:before {
        content: '*';
        display: inline-block;
        color: red;
      }
    }
  }
  .btn-check-flow {
    /* position: absolute;
    right: 32px;
    top: 50%;
    transform: translateY(-50%); */
  }
  .download-main {
    margin-right: 32px;
    .line {
      position: relative;
      top: 5px;
      left: -6px;
    }
    .row {
      display: flex;
      justify-content: flex-end;
    }
  }
  .spin-icon-load {
    animation: ani-spin 1s linear infinite;
  }
  @keyframes ani-spin {
    from {
      transform: rotate(0deg);
    }
    50% {
      transform: rotate(180deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
}
</style>
